import * as React from 'react';
import accounting from 'accounting';

import ItemModel, { ISubItem } from 'src/model/cartItem.model';

import { ifLoggedIn, goToCart, cartUrl } from 'src/utils/navigation';
import './ProductsList.scss';
import { IWarrantyProvider } from 'src/model/warranty.model';
import env from 'src/shared/env';
import { goToPartDetail, partDetailUrl } from 'src/utils/navigation';
import IconMessage from 'src/components/common/IconMessage';
import dropShipIcon from 'src/assets/dropship';

interface IProductsListProps {
  orderConfirmed: boolean;
  items: { [key: number]: ItemModel };
  deliverMethod: string;
  warrantyProviders: IWarrantyProvider[];
  getWarranyProviders: () => void;
  t?: any;
  deliveryLocation?: any;
}

class ProductsList extends React.Component<IProductsListProps, any> {
  constructor(props: any) {
    super(props);
  }

  public componentDidMount = () => {
    this.props.getWarranyProviders();
  };

  private goToCart = () => ifLoggedIn(() => goToCart());

  private getWarrantyProviderName(code: string): string {
    const provider = this.props.warrantyProviders.find(
      prov => prov.providerNumberString === code
    );
    if (provider != null) {
      return provider.warrantyClaimNumber;
    }
    return 'Loading...';
  }

  public showShippingFrom = (itemDeliveryAddress: ItemModel) => {
    if (this.props.deliverMethod === 'Shipping') {
      return true;
    }
    const { shipsfrom } = itemDeliveryAddress;
    if (
      shipsfrom.addressLine1 === this.props.deliveryLocation?.addressLine1 &&
      shipsfrom.addressLine2 === this.props.deliveryLocation?.addressLine2 &&
      shipsfrom.code === this.props.deliveryLocation?.code &&
      shipsfrom.name === this.props.deliveryLocation?.name &&
      shipsfrom.postalCode === this.props.deliveryLocation?.postalCode &&
      shipsfrom.stateCode === this.props.deliveryLocation?.stateCode
    ) {
      return false;
    } else {
      return true;
    }
  };

  public render() {
    const { t } = this.props;
    return (
      <table className="rp-products-list">
        <tbody>
          <tr className="rp-products-list--title">
            <td>
              {t('menu.cart')}
              {!this.props.orderConfirmed && (
                <a
                  href={cartUrl()}
                  onClick={this.goToCart}
                  className="rp-products-list--link"
                >
                  {t('checkoutPage.editCart')}
                </a>
              )}
            </td>
          </tr>
          {this.props.items && (
            <tr className="rp-products-list--table">
              <td>
                <table style={{ width: '100%' }}>
                  <tbody>
                    {Object.keys(this.props.items).map(key => {
                      return (
                        <tr className="rp-products-list--table-row" key={key}>
                          <td className="rp-products-list-inner-table">
                            <table style={{ width: '100%' }}>
                              {/* First Row*/}
                              <tr className="rp-products-list--table-row-head">
                                <td className="rp-products-list--table-large-column name">
                                  {this.props.items[key].name}
                                </td>
                                <td className="rp-products-list--table-short-column">
                                  {t('myFavourites.qty')}:
                                </td>
                                <td className="rp-products-list--table-column">
                                  {t('myFavourites.shipmentMarking')}:
                                </td>
                                {env.REACT_APP_BASE_ENVIRONMENT === 'US' ? (
                                  <td className="rp-products-list--table-column">
                                    {t('product.warrantyProvider')}:
                                  </td>
                                ) : (
                                  ''
                                )}
                                <td className="rp-products-list--table-column">
                                  {env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                                    ? `${t('product.ticket')} / ${t(
                                        'product.dispatch#'
                                      )}:`
                                    : `${t('myFavourites.dispatch')} / ${t(
                                        'product.claims_plural'
                                      )}:`}
                                </td>
                                <td className="rp-products-list--table-column">
                                  {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
                                    <div
                                      className={
                                        this.showShippingFrom(
                                          this.props.items[key]
                                        )
                                          ? ''
                                          : 'disable'
                                      }
                                    >
                                      {t('checkoutPage.shippingFrom')}:
                                    </div>
                                  ) : (
                                    <div
                                      className={
                                        this.props.deliverMethod === 'Shipping'
                                          ? ''
                                          : 'disable'
                                      }
                                    >
                                      {t('checkoutPage.shippingFrom')}:
                                    </div>
                                  )}
                                </td>
                                <td className="rp-products-list--table-column">
                                  {t('cartPage.unitPrice')}:
                                </td>
                                <td className="rp-products-list--table-column">
                                  {t('myFavourites.itemTotal')}:
                                </td>
                                <td className="rp-products-list--table-column"/>
                              </tr>
                              {/* Second Row*/}
                              <tr className="rp-products-list--table-row-info">
                                <td className="rp-products-list--table-large-column description">
                                  {this.props.items[key].description}
                                </td>
                                <td className="rp-products-list--table-short-column">
                                  {this.props.items[key].quantity
                                    ? this.props.items[key].quantity
                                    : 0}
                                </td>
                                <td className="rp-products-list--table-column">
                                  {this.props.items[key].shipmentMarking
                                    ? this.props.items[key].shipmentMarking
                                    : 'NA'}
                                </td>
                                {env.REACT_APP_BASE_ENVIRONMENT === 'US' ? (
                                  <td className="rp-products-list--table-column">
                                    {this.props.items[key].warrantyProvider
                                      ? this.getWarrantyProviderName(
                                          this.props.items[key].warrantyProvider
                                        )
                                      : 'NA'}
                                  </td>
                                ) : (
                                  ''
                                )}
                                <td className="rp-products-list--table-column">
                                  {env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                                    ? this.props.items[key].ticketNumber
                                      ? this.props.items[key].ticketNumber
                                      : 'NA'
                                    : this.props.items[key].claims
                                    ? this.props.items[key].claims
                                    : 'NA'}
                                </td>
                                {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
                                  <td className="rp-products-list--table-column ship-from">
                                    {this.showShippingFrom(
                                      this.props.items[key]
                                    )
                                      ? this.props.items[key].shipsfrom
                                          .addressLine4 &&
                                        this.props.items[key].shipsfrom
                                          .stateCode
                                        ? `${this.props.items[
                                            key
                                          ].shipsfrom.addressLine4.toLocaleLowerCase()}, ${this.props.items[
                                            key
                                          ].shipsfrom.stateCode.toUpperCase()}`
                                        : 'NA'
                                      : ''}
                                  </td>
                                ) : (
                                  <td className="rp-products-list--table-column ship-from">
                                    {this.props.deliverMethod === 'Shipping'
                                      ? this.props.items[key].shipsfrom
                                          .addressLine4 &&
                                        this.props.items[key].shipsfrom
                                          .stateCode
                                        ? `${this.props.items[
                                            key
                                          ].shipsfrom.addressLine4.toLocaleLowerCase()}, ${this.props.items[
                                            key
                                          ].shipsfrom.stateCode.toUpperCase()}`
                                        : 'NA'
                                      : ''}
                                  </td>
                                )}
                                <td className="rp-products-list--table-column price">
                                  {this.props.items[key].unitPrice
                                    ? accounting.formatMoney(
                                        this.props.items[key].unitPrice
                                      )
                                    : 'NA'}
                                </td>
                                <td className="rp-products-list--table-column price">
                                  {this.props.items[key].itemTotal
                                    ? accounting.formatMoney(
                                        this.props.items[key].itemTotal
                                      )
                                    : 'NA'}
                                </td>
                                <td className="rp-products-list--table-column status">
                                 
                                    {this.props.items[key].specialOrder && (
                                    <div className="special-order">
                                      <i className={`rpds rpds-new-releases`} />
                                      {t('general.nonReturn')}
                                    </div>
                                  )}
                                    {this.props.items[key].isDropShip && (
                                    <div className="special-order">
                                    <span><img src={dropShipIcon} alt="Dropship Only" className="dropship-icon-checkout" /></span>
                                    <span>{t('general.dropShipOnly')}</span>
                                    </div>
                                  )}
                                </td>
                              </tr>
                              {this.props.items[key].subItems &&
                                this.props.items[key].subItems.length > 0 && (
                                  <tr>
                                  <td colSpan={8}>
                                <table className="rp-products-list--table-subitems">
                                  {this.props.items[key].subItems.map(
                                    (subItem: ISubItem, i: number) => {
                                      return (
                                        subItem.totalAmount>0 && ( 
                                        <React.Fragment key={i}>
                                          <tr className="rp-products-list--table-row-head">
                                            <td className="rp-products-list--table-large-column name">
                                             {subItem.productNumber}
                                            </td>
                                            <td className="rp-products-list--table-short-column">
                                              {t('myFavourites.qty')}:
                                            </td>
                                            <td className="rp-products-list--table-column" />
                                            <td className="rp-products-list--table-column" />
                                            <td className="rp-products-list--table-column" />
                                            <td className="rp-products-list--table-column" />
                                            <td className="rp-products-list--table-column">
                                              {t('cartPage.unitPrice')}:
                                            </td>
                                            <td className="rp-products-list--table-column">
                                              {t('myFavourites.itemTotal')}:
                                            </td>
                                          
                                          </tr>
                                          <tr className="rp-products-list--table-row-info">
                                            <td className="rp-products-list--table-large-column description">
                                              {subItem.description}
                                            </td>
                                            <td className="rp-products-list--table-short-column">
                                              {subItem.quantity
                                                ? subItem.quantity
                                                : 0}
                                            </td>
                                            <td className="rp-products-list--table-column" />
                                            <td className="rp-products-list--table-column" />
                                            <td className="rp-products-list--table-column" />
                                            <td className="rp-products-list--table-column" />
                                            <td className="rp-products-list--table-column price">
                                              {subItem.partnerPrice
                                                ? accounting.formatMoney(
                                                    subItem.partnerPrice
                                                  )
                                                : 'NA'}
                                            </td>
                                            <td className="rp-products-list--table-column price">
                                              {subItem.totalAmount
                                                ? accounting.formatMoney(
                                                    subItem.totalAmount
                                                  )
                                                : 'NA'}
                                            </td>
                                          </tr>
                                        </React.Fragment>
                                         )
                                      );
                                    }
                                  )}
                                </table>
                                </td>
                                </tr>
                                )}
                              {/* Third Row*/}
                              <tr className="rp-products-list--table-all">
                                <div>
                                  <td className="rp-products-list--table-column name">
                                    {this.props.items[key].name}
                                    <label>
                                      {this.props.items[key].description}
                                    </label>
                                  </td>
                                  <td className="rp-products-list--table-column">
                                    <label>{t('myFavourites.qty')}:</label>
                                    {this.props.items[key].quantity
                                      ? this.props.items[key].quantity
                                      : 0}
                                  </td>
                                  <td className="rp-products-list--table-column">
                                    <label>
                                      {t('myFavourites.shipmentMarking')}:
                                    </label>
                                    {this.props.items[key].shipmentMarking
                                      ? this.props.items[key].shipmentMarking
                                      : 'NA'}
                                  </td>
                                  <td className="rp-products-list--table-column">
                                    <label>
                                      {t('product.warrantyProvider')}:
                                    </label>
                                    {this.props.items[key].warrantyProvider
                                      ? this.getWarrantyProviderName(
                                          this.props.items[key].warrantyProvider
                                        )
                                      : 'NA'}
                                  </td>
                                  <td className="rp-products-list--table-column">
                                    <label>
                                      {t('myFavourites.dispatch')} / $
                                      {t('product.claims_plural')}:
                                    </label>
                                    {this.props.items[key].claims
                                      ? this.props.items[key].claims
                                      : 'NA'}
                                  </td>
                                  {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
                                    <td className="rp-products-list--table-column ship-from">
                                      <label
                                        className={
                                          this.showShippingFrom(
                                            this.props.items[key]
                                          )
                                            ? ''
                                            : 'disable'
                                        }
                                      >
                                        {t('checkoutPage.shippingFrom')}:
                                      </label>
                                      {this.showShippingFrom(
                                        this.props.items[key]
                                      )
                                        ? this.props.items[key].shipsfrom
                                            .addressLine4 &&
                                          this.props.items[key].shipsfrom
                                            .stateCode
                                          ? `${this.props.items[
                                              key
                                            ].shipsfrom.addressLine4.toLocaleLowerCase()}, ${this.props.items[
                                              key
                                            ].shipsfrom.stateCode.toUpperCase()}`
                                          : 'NA'
                                        : ''}
                                    </td>
                                  ) : (
                                    <td className="rp-products-list--table-column ship-from">
                                      <label
                                        className={
                                          this.props.deliverMethod ===
                                          'Shipping'
                                            ? ''
                                            : 'disable'
                                        }
                                      >
                                        {t('checkoutPage.shippingFrom')}:
                                      </label>
                                      {this.props.deliverMethod === 'Shipping'
                                        ? this.props.items[key].shipsfrom
                                            .addressLine4 &&
                                          this.props.items[key].shipsfrom
                                            .stateCode
                                          ? `${this.props.items[
                                              key
                                            ].shipsfrom.addressLine4.toLocaleLowerCase()}, ${this.props.items[
                                              key
                                            ].shipsfrom.stateCode.toUpperCase()}`
                                          : 'NA'
                                        : ''}
                                    </td>
                                  )}
                                  <td className="rp-products-list--table-column-prices">
                                    <div className="rp-products-list--table-column">
                                      <label>{t('cartPage.unitPrice')}:</label>
                                      {this.props.items[key].unitPrice
                                        ? accounting.formatMoney(
                                            this.props.items[key].unitPrice
                                          )
                                        : 'NA'}
                                    </div>
                                    <div className="rp-products-list--table-column">
                                      <label>
                                        {t('myFavourites.itemTotal')}:
                                      </label>
                                      {this.props.items[key].itemTotal
                                        ? accounting.formatMoney(
                                            this.props.items[key].itemTotal
                                          )
                                        : 'NA'}
                                    </div>
                                  </td>
                                  <td className="rp-products-list--table-column-prices">
                                  <div className="rp-products-list--table-column">
                                  {this.props.items[key].specialOrder && (
                                    <div className="special-order">
                                      <i className={`rpds rpds-new-releases`} />
                                      {t('general.nonReturn')}
                                    </div>
                                  )}
                                    {this.props.items[key].isDropShip && (
                                    <div className="special-order">
                                      <span><img src={dropShipIcon} alt="Dropship Only" className="dropship-icon-checkout" /></span>
                                      <span>{t('general.dropShipOnly')}</span>
                                    </div>
                                  )}
                                  </div>
                                  </td>
                                  {this.props.items[key].subItems &&
                                    this.props.items[key].subItems.length >
                                      0 && (
                                      <div className="rp-products-list--table-subitems--mobile">
                                        {this.props.items[key].subItems.map(
                                          (subItem: ISubItem, i: number) => {
                                            return (
                                              subItem.totalAmount>0 && ( 
                                              <React.Fragment key={i}>
                                                <div className="rp-products-list--table-column name">
                                                 {subItem.productNumber}
                                                  <label>
                                                    {subItem.description}
                                                  </label>
                                                </div>
                                                <div className="rp-products-list--table-column">
                                                  <label>
                                                    {t('myFavourites.qty')}:
                                                  </label>
                                                  {subItem.quantity
                                                    ? subItem.quantity
                                                    : 0}
                                                </div>
                                                <div className="rp-products-list--table-column-prices">
                                                  <div className="rp-products-list--table-column">
                                                    <label>
                                                      {t('cartPage.unitPrice')}:
                                                    </label>
                                                    {subItem.partnerPrice
                                                      ? accounting.formatMoney(
                                                          subItem.partnerPrice
                                                        )
                                                      : 'NA'}
                                                  </div>
                                                  <div className="rp-products-list--table-column">
                                                    <label>
                                                      {t(
                                                        'myFavourites.itemTotal'
                                                      )}
                                                      :
                                                    </label>
                                                    {subItem.totalAmount
                                                      ? accounting.formatMoney(
                                                          subItem.totalAmount
                                                        )
                                                      : 'NA'}
                                                  </div>
                                                </div>
                                              </React.Fragment>
                                              )
                                            );
                                          }
                                        )}
                                      </div>
                                    )}
                                </div>
                              </tr>
                              {this.props.items[key].replacementMfc &&
                              this.props.items[key].replacementPart ? (
                                <button
                                  className="subavailable"
                                  onClick={e =>
                                    goToPartDetail(
                                      `${this.props.items[key].replacementMfc}  ${this.props.items[key].replacementPart}`
                                    )
                                  }
                                >
                                  {t('myFavourites.subavailable')}
                                </button>
                              ) : (
                                ''
                              )}

                              {/* FOurth Row*/}

                              <tr className="rp-products-list--table-alert">
                                {this.props.items[key].quantity >
                                  this.props.items[key].amountInStock && (
                                  <td
                                    colSpan={7}
                                    className={
                                      this.props.items[key].rushOrder
                                        ? 'rush'
                                        : 'disclaimer'
                                    }
                                  >
                                    <i className="rpds-local-shipping" />
                                    {env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                                      ? this.props.items[key].rushOrder
                                        ? `${t('common.orderConatinBckRush')}`
                                        : `${t('common.itemsBackOrderedOnly')}`
                                      : `${this.props.items[key].quantity -
                                          this.props.items[key]
                                            .amountInStock} item(s) will be backordered. We will ship them as soon as the stocks are available for shipment.`}
                                  </td>
                                )}
                              </tr>
                            </table>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }
}

export default ProductsList;
